import React from "react";

export const FinishedEditBanner: React.FC<{
  edit: { allowed: boolean; reason?: string | null };
}> = ({ edit }) => (
  <div
    data-testid="finished-edit-banner"
    className="rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
  >
    {edit.allowed
      ? "Editing a finished session. Each Save changes only the rows you saved; the confirm box lists them."
      : `This finished session cannot be edited now. ${edit.reason ?? ""}`}
  </div>
);
